import { theme } from "@tm/utility/global";
import styled from "styled-components";
import { deviceType } from "../../../../utils";

export const OrderDataCard = styled.div`
  background: ${theme.whiteText};
  border-radius: 16px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 20px;
  picture {
    display: inherit;
    flex-shrink: 0;
  }
  @media ${deviceType.mobile} {
    padding: 16px 16px 12px;
    border-radius: 0px;
  }
`;

export const OrderDataIconWrapper = styled.div`
  overflow: hidden;
  border: none;
  border-radius: 4px;
  flex-shrink: 0;
  img {
    height: 48px;
    width: auto;
    object-fit: contain;
  }
  @media ${deviceType.mobile} {
    img {
      height: 36px;
    }
  }
`;

export const SeparatorWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 -32px;
  @media ${deviceType.mobile} {
    margin: 0 -28px;
  }
`;

export const SeparatorCircle = styled.div<{ color?: string }>`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: ${(props) => props.color || theme.disabledGrey2};
  flex-shrink: 0;
`;

export const SeparatorLine = styled.div`
  flex: 1;
  border-top: 2px dashed ${theme.gainsBoro};
`;

// ── GI mobile layout ────────────────────────────────────────────────────────

export const GICard = styled.div`
  background: ${theme.whiteText};
  border-radius: 12px;
  overflow: hidden;
  padding: 16px 0 0;
`;

export const GITitle = styled.span`
  display: block;
  font-size: 16px;
  font-weight: 600;
  color: #222222;
  padding: 0 16px 12px;
`;

export const GIDetailRow = styled.div`
  padding: 0 16px;
`;

export const GIDetailLabel = styled.span`
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: #222222;
  padding-bottom: 8px;
`;

export const GIDetailValue = styled.span`
  display: block;
  font-size: 14px;
  font-weight: 400;
  color: #222222;
`;

export const GIDashedDivider = styled.div`
  height: 24px;
  display: flex;
  align-items: center;
  padding: 0 16px;
  &::after {
    content: "";
    flex: 1;
    border-top: 1px dashed #e4e4e4;
  }
`;
